import { useState } from "react";
import { CarButton, CarLoadingButton } from "./Buttons";
import { BaseDialog } from "./BaseDialog";
import { Box, Divider, Typography } from "@mui/material";
import { CarStatusSuccess } from "./Icons";

export interface ShowMessageDialogProps {
  onApply: (value: boolean) => void;
  onCancel: () => void;
  label: string;
  message: JSX.Element | string;
  cancelLabel?: string;
}

export const ShowMessageDialog = (props: ShowMessageDialogProps) => {
  return (
    <BaseDialog
      hideCloseButton
      onClose={props.onCancel}
      actions={
        <>
          <CarButton
            sx={{ alignSelf: "center", fontSize: "18px" }}
            onClick={() => {
              props.onCancel();
            }}
            variant="outlined"
          >
            {props.cancelLabel ?? "Close"}
          </CarButton>
        </>
      }
    >
      <Box
        sx={{
          gap: 1.5,
          minHeight: 140,
          maxWidth: 340,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h4SemiBold" sx={{ fontSize: "25px" }}>
          {props.label}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {typeof props.message === "string" ? (
          <Typography sx={{ mt: 1 }} variant="par01Regular">
            {props.message}
          </Typography>
        ) : (
          props.message
        )}
      </Box>
    </BaseDialog>
  );
};
